export class BannerService {
  icon: string;
  label: string;
  constructor(icon: string, label: string) {
    this.icon = icon;
    this.label = label;
  }
}
